var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconParkOutlineMaterial = function SvgIconParkOutlineMaterial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#4D4D4D",
    strokeLinejoin: "round",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2.6,
    d: "M10 18.333A8.333 8.333 0 0 0 18.333 10a8.333 8.333 0 1 0-16.666 0A8.333 8.333 0 0 0 10 18.333Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M10 15a5 5 0 0 0 5-5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgIconParkOutlineMaterial;